import React, { useRef } from 'react';
import ChatWindow from '../components/chat/ChatWindow';
import ChatList from '../components/chat/ChatList';
import ChatListHeader from '../components/chat/ChatListHeader';
import EscalationBanner from '../components/chat/EscalationBanner';
import { useNavigate } from 'react-router-dom';
import DashboardContainer from '../components/layout/DashboardContainer';
import { useChatContext } from '../context/ChatContext';


const MainPage = () => {
  const navigate = useNavigate();
  const {
    clientProfile,
    customers,
    selectedCustomer,
    escalations,
    handleCustomerSelect,
    handleNameUpdate,
    handleDeleteConversation,
    reloadProfile,
    reloadCustomers,
    loading,
    error,
  } = useChatContext();
  const chatWindowRef = useRef();

  if (loading) {
    return <div style={{ padding: 20 }}>Loading your dashboard...</div>;
  }

  if (error) {
    return <div style={{ padding: 20, color: 'red' }}>Error: {error}</div>;
  }

  const selectedCustomerData = customers.find(c => c.customer_id === selectedCustomer);

  return (
    <DashboardContainer>
      <div style={{ padding: '16px' }}>
        <EscalationBanner
          escalations={escalations}
          onView={(customerId) => handleCustomerSelect(customerId)}
        />
      </div>
      <div className={`dashboard-layout ${selectedCustomer ? 'chat-active' : ''}`}>
        <div className="secondary-panel">
          <ChatListHeader client={clientProfile} />
          <div className="chat-list-container">
            <ChatList
              customers={customers}
              selected={selectedCustomer}
              onSelect={handleCustomerSelect}
              onDelete={handleDeleteConversation}
              onCustomerCreated={reloadCustomers}
            />
          </div>
        </div>
        <div className="chat-area">
          <ChatWindow
            ref={chatWindowRef}
            customerId={selectedCustomer}
            customerName={selectedCustomerData?.name}
            onNameUpdate={handleNameUpdate}
            onBack={() => handleCustomerSelect(null)}
            key={selectedCustomer}
          />
        </div>
      </div>
    </DashboardContainer>
  );
};

export default MainPage;
